import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  ADBS_STOP_POLL_DELAY,
  ADBS_STOP_POLL_INTERVAL,
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface AdbsStopProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const AdbsStop = (
  { location, databaseId, onExecute }: AdbsStopProps,
): JSX.Element => {
  const { invokeCall: invokeStop } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).adbsDatabaseApi.stopAdbsDatabase },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resGroup = decodeURIComponent(resourceGroup || "");
    const resName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.stopAdbs(),
          message: Messages.notifications.inProgress.messages.stopAdbs(resName),
        },
        success: {
          title: Messages.notifications.success.titles.stopAdbs(),
          message: Messages.notifications.success.messages.stopAdbs(resName),
        },
        failure: {
          title: Messages.notifications.failure.titles.stop(),
          message: Messages.notifications.failure.messages.stopAdbs(resName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.ADBS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName: resGroup,
            databaseName: resName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.ADBS_STOPPED_CHECK,
          delay: ADBS_STOP_POLL_DELAY,
          interval: ADBS_STOP_POLL_INTERVAL,
        },
      },
    };
    invokeStop({
      subscriptionId,
      resourceGroupName: resGroup,
      databaseName: resName,
    }, invokeOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newAdbsStop = (
  props: AdbsStopProps,
): JSX.Element => (<AdbsStop {...props} />);
